<template>
    <div>
        <div class="text-warning text-center m-sm-2 m-md-4">
            <i class="fas fa-exclamation-triangle fa-4x mr-2"></i>
            <span class="h1">{{ $t('outOfActivityRange') }}</span>
        </div>

        <h3 class="text-center">Активен от: {{ moment(activeFrom).format('DD.MM.YYYY HH:mm') }} до: {{ moment(activeTo).format('DD.MM.YYYY HH:mm') }}</h3>

        <div v-if="upcoming" class="m-sm-2 m-md-4">
            <flip-countdown :deadline="deadlineStr" :labels="timerLabels"></flip-countdown>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import FlipCountdown from 'vue2-flip-countdown'

    export default {
        props: {
            activeFrom: {
                type: [Date, String],
                default: null
            },
            activeTo: {
                type: [Date, String],
                default: null
            }
        },
        components: {
            FlipCountdown
        },
        data() {
            return {
                moment: moment,
                fmt: 'YYYY-MM-DD HH:mm:ss',
                timerLabels: {
                    days: this.$t('timer.labels.days'),
                    hours: this.$t('timer.labels.hours'),
                    minutes: this.$t('timer.labels.minutes'),
                    seconds: this.$t('timer.labels.seconds'),
                }
            }
        },
        computed: {
            upcoming() {
                if (!this.deadline) {
                    return false;
                }

                let now = this.moment();
                return now < this.deadline;
            },
            deadline() {
                return this.moment(this.activeFrom);
            },
            deadlineStr() {
                return this.moment(this.deadline).format(this.fmt);
            }
        },
    }
</script>

<style scoped>
</style>
